import React from 'react'
import PropTypes from 'prop-types'
import { Button, message } from 'antd'
import { SoundOutlined } from '@ant-design/icons'
import WrappedModal from '@/components/WrappedModal'
import SurveillanceAlertTtsSettingsForm from './SurveillanceAlertTtsSettingsForm'
import { saveAlertTtsSettings } from './surveillanceAlertTts'

/**
 * 告警语音设置弹窗：语速 / 音调 / 音量 / 总开关 / 无婴儿重复，写入 localStorage。
 */
class SurveillanceAlertTtsSettingsModal extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    onSuccess: PropTypes.func,
    title: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }

  static defaultProps = {
    title: '告警语音设置',
    width: 420
  }

  handleOk = async (formRef) => {
    const { onSuccess } = this.props
    const fields = await formRef.current.validateFields()
    saveAlertTtsSettings(fields)
    message.success('语音设置已保存')
    if (typeof onSuccess === 'function') onSuccess(fields)
  }

  render () {
    const { children, title, width } = this.props
    const trigger = children != null
      ? children
      : (
        <Button type="default" size="small" icon={<SoundOutlined />}>
          语音设置
        </Button>
        )

    return (
      <WrappedModal
        children={trigger}
        title={title}
        width={width}
        destroyOnClose
        maskClosable
        baseComponent={<SurveillanceAlertTtsSettingsForm />}
        baseProps={{ formKey: 'alert-tts-settings' }}
        onOk={this.handleOk}
        okText="保存"
      />
    )
  }
}

export default SurveillanceAlertTtsSettingsModal
